export const mergeAriaIds = (
  ...ids: Array<string | null | undefined | false>
): string | undefined => {
  const merged = ids.filter(Boolean).join(" ");
  return merged || undefined;
};
